import { ComponentProps, forwardRef } from 'react';

import { mergeClasses } from '@/utils';

import { TEXTAREA_VARIANTS, TEXTAREA_LABEL_VARIANTS } from './Textarea.constants';
import { Label } from '../Label';

interface ITextarea extends ComponentProps<'textarea'> {
  label?: string;
  error?: string;
  size?: 'sm' | 'default' | 'lg';
  variant?: 'default' | 'error';
  resize?: 'resize' | 'resize-none' | 'resize-x' | 'resize-y';
}

const Textarea = forwardRef<HTMLTextAreaElement, ITextarea>(
  (
    {
      className,
      label,
      error,
      required,
      size = 'default',
      variant,
      disabled,
      resize = 'resize-none',
      ...props
    },
    ref,
  ) => {
    const resolvedVariant = error ? 'error' : variant;

    return (
      <div className={mergeClasses('flex flex-col gap-2 w-full', className)}>
        {label && (
          <Label required={required} className={mergeClasses(TEXTAREA_LABEL_VARIANTS({ size }))}>
            {label}
          </Label>
        )}

        <textarea
          ref={ref}
          data-slot="textarea"
          className={mergeClasses(
            TEXTAREA_VARIANTS({ size, variant: resolvedVariant, disabled }),
            error && '!border-semantic-error-base',
            resize,
          )}
          disabled={disabled}
          {...props}
        />

        {error && <p className="text-xs leading-5 text-semantic-error-base">{error}</p>}
      </div>
    );
  },
);

Textarea.displayName = 'Textarea';

export { Textarea };
export type { ITextarea };
